import React from "react";
import LegalDocument from "../../components/LegalDocument";
import TermsMarkdown from "../../content/markdown/legal/TermsOfUse.md";

const SectionTermsOfUse = () => <LegalDocument markdownPath={TermsMarkdown} />;

export default SectionTermsOfUse;
